
class customWishlist extends HTMLElement {
    constructor() {
        super();
        this.productID = this.dataset.id;
        this.customer_id = this.dataset.customer_id;
        this.type = this.dataset.type;

        this.productType = this.dataset.product_type;
        this.featured_image = window.globalSpace.product.featured_image;
        this.varientID = this.dataset.varientid;
        this.checkvariINwishlist();
        
        this.addEventListener('click', () => this.manageWishlist(this));
        this.variantOptions = this.closest('.product-form')?.querySelectorAll('[data-optionindex], [data-ring-size]');
        this.variantRadioOptions = this.closest('.product-form')?.querySelectorAll('[data-stone-size], [data-metal-tone], [data-metal-type], fieldset');

    }
    checkvariINwishlist() {
        let variant_id = this.varientID;
        
        if (this.customer_id !== null && this.customer_id !== '') {
            const endpoint = `https://certificate-manager.diamondrensu.com/api/wishlist?customer_id=${this.customer_id}&variant_id=${this.varientID}`;
            fetch(endpoint, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Shop': 'diamondrensu-australia.myshopify.com',
                }
            })
            .then(response => response.json())
            .then(data => {
                let addedWishlistdata = data.data.data;
                addedWishlistdata.forEach((ele) => {
                    if (variant_id == ele.variant_id) {
                        this.classList.add('wishlist_added');
                    }
                });
            })
            .catch(error => {
                console.error('Error fetching wishlist data from API:', error);
            });
        } else {
            
            let wishlist = JSON.parse(localStorage.getItem('wishlist')) || { items: [] };
            
            const isInWishlist = wishlist.items.some(
                item => item.variant_id === variant_id && item.product_id === this.productID
            );
    
            
            if (isInWishlist) {
                this.classList.add('wishlist_added');
            } else {
                this.classList.remove('wishlist_added');
            }
        }
    }
    
    



    manageWishlist() {
        let line_item_properties = {};
        var variantsHasOptions = true;
        var variantsHasRadioOptions = true;
    
        
        this.varientID = document.querySelector('.product-form')?.querySelector('[name="id"]').value || this.dataset.varientid;
    
        // Define requiredData outside the conditional blocks
        const requiredData = {
            customer_id: this.customer_id ? parseInt(this.customer_id, 10) : null,
            shop: "diamondrensu-new.myshopify.com",
            product_id: this.productID,
            variant_id: this.varientID,
            product_title: window.globalSpace.product.title,
            handle:window.globalSpace.product.handle,
            item_qty: 1,
            image: this.featured_image,
            type:this.type,
            product_price: this.dataset.price,
            product_compare_price : this.dataset.comapre_at_price,
            is_save_later: false,
            line_item_properties: line_item_properties,
        };
    
        if (!this.classList.contains('wishlist_added')) {
             
    
                line_item_properties = {

                };
                

                

                // Assign the line_item_properties to requiredData
                requiredData.line_item_properties = line_item_properties;
            
    
            if (this.customer_id) {
                if (variantsHasOptions && variantsHasRadioOptions) {
                 this.addToWishlist([requiredData]);
                }
            } else {
                if (variantsHasOptions && variantsHasRadioOptions) {
                    this.updateWishlist(requiredData);    
                }
            }
        } else {
            // Remove from wishlist
            if (this.customer_id) {
                // Customer is logged in, make API call
                this.removeToWishlist();
            } else {
                // Customer is not logged in, update localStorage
                this.removeFromLocalWishlist();
            }
        }
    }
    
    
    removeFromLocalWishlist() {
        let wishlist = JSON.parse(localStorage.getItem('wishlist')) || { items: [] };
        wishlist.items = wishlist.items.filter(
            item => !(item.product_id === this.productID && item.variant_id === this.varientID)
        );
        localStorage.setItem('wishlist', JSON.stringify(wishlist));
        this.classList.remove('wishlist_added');
    }
    
    


    removeToWishlist() {
        console.log("tests");
        if (this.customer_id) {
            // For logged-in customers, proceed with API call to remove item from wishlist
            const endpoint = "https://certificate-manager.diamondrensu.com/api/wishlist/remove";
            const body = {
                customer_id: this.customer_id,
                product_id: this.productID,
                variant_id: this.varientID
            };
    
            fetch(endpoint, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Shop': 'diamondrensu-australia.myshopify.com',
                },
                body: JSON.stringify(body)
            })
            .then(response => response.json())
            .then(data => {
                this.classList.remove('wishlist_added');
                window.notificationEle.updateNotification('','Item has been successfully removed from your wishlist', {
                    type: 'success',
                    timeout: 3000
                  });
            })
            .catch(error => {
                console.error("Error:", error);
            });
        } else {
            
            let wishlist = JSON.parse(localStorage.getItem('wishlist')) || { items: [] };
            wishlist.items = wishlist.items.filter(
                item => !(item.product_id === this.productID && item.variant_id === this.varientID)
            );
            localStorage.setItem('wishlist', JSON.stringify(wishlist));
            this.classList.remove('wishlist_added');
        }
    }
    


    addToWishlist(items) {
        const endpoint = "https://certificate-manager.diamondrensu.com/api/wishlist/addbulkwishlist";
        
        fetch(endpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Shop': 'diamondrensu-new.myshopify.com',
            },
            body: JSON.stringify({ items })
        })
        .then(response => response.json())
        .then(data => {
            this.classList.add('wishlist_added');
            window.notificationEle.updateNotification('','Item has been successfully added to wishlist, view  My Wishlist', {
                type: 'success',
                timeout: 3000
              });
            
        })
        .catch(error => {
            console.error('Error:', error);
        });
    }

    updateWishlist(newItem) {
        let wishlist = JSON.parse(localStorage.getItem('wishlist')) || { items: [] };
        const existingIndex = wishlist.items.findIndex(
            item => item.product_id === newItem.product_id && item.variant_id === newItem.variant_id
        );

        if (existingIndex > -1) {
            wishlist.items[existingIndex] = newItem;
        } else {
            wishlist.items.push(newItem);
        }
        localStorage.setItem('wishlist', JSON.stringify(wishlist));
        window.notificationEle.updateNotification('','Item has been temporarily added to wishlist, please <a href="/account">login</a> to save it permanently', {
            type: 'error',
            timeout: 3000
          });
        this.classList.add('wishlist_added');
    }

        /**
     * Scroll to error when product form field is required and empty
     * 
     * @param {element} node target element
     */

    scrollToField(element) {
        let offsetTop = element.getBoundingClientRect().top;
        let offsetPosition = offsetTop + window.pageYOffset - 250;

        window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
        });
    }
}

customElements.define('custom-wishlist', customWishlist);
